import { PermissionsGroupsEnumType, RoleEnumTypeV2 } from '@/features/auth/types'
import type { V1GroupDataType, V2GroupType } from '@/features/groups/types'
import checkPermissionsGroup from '@/features/users/utils'

export function getMentees(user: V2GroupType['users'][number] | V1GroupDataType['groupUsers'][number]) {
  return user.roles.includes(RoleEnumTypeV2.MENTEE)
}

export function getMentor(user: V2GroupType['users'][number] | V1GroupDataType['groupUsers'][number]) {
  return user.roles.includes(RoleEnumTypeV2.MENTOR)
}

export function getManager(user: V2GroupType['users'][number] | V1GroupDataType['groupUsers'][number]) {
  return user.roles.includes(RoleEnumTypeV2.MANAGER)
}

export function formGroupName(group: V1GroupDataType) {
  // if the group has a name, return it
  if (group.name) {
    return group.name
  }

  // list of names like : mentor firstname, mentee firstname, mentee firstname"
  // mentor firstname should be the first in the group name
  // should take only the first 4 users and add a "+X" at the end if there are more than 4 users
  const USERS_LIMIT = 4
  return group.groupUsers
    .filter((groupUser) => checkPermissionsGroup(groupUser.roles, PermissionsGroupsEnumType.USER))
    .sort((a, b) => {
      if (getMentor(a)) return -1
      if (getMentor(b)) return 1
      return 0
    })
    .slice(0, USERS_LIMIT)
    .map((groupUser) => groupUser.user.identity.firstname)
    .join(', ')
    .concat(
      group.groupUsers.length > USERS_LIMIT
        ? `, +${group.groupUsers.slice(USERS_LIMIT, group.groupUsers.length).length}`
        : '',
    )
}
